/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconHammer: {
  name: 'hammer';
  data: string;
} = {
  name: 'hammer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m543.918 139.772-81.489-12.266 23.764-31.408-98.574-75.246-25.049 33.099c-40.795-24.1-82.778-34.517-113.769-31.348l.005.027c-4.428.425-8.629 1.494-12.572 2.481-12.378 3.109-21.999 8.786-28.067 16.809l103.667 79.102-23.121 30.563 19.482 14.871C203.366 295.413 83.255 405.922 15.69 554.794l59.385 44.95c127.293-110.584 195.543-247.92 293.792-386.979l18.42 14.06 23.764-31.408 33.961 75.082 50.932 38.531c62.577-26.304 90.454-72.846 98.908-130.716l-50.934-38.542z"/></svg>`,
};
